import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import ChromelessControl from './ChromelessControl';
import { ContextConsumer } from './Context';
var HIDE_CHROME_DELAY = 500;
export var ContentBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ContentBase, _React$PureComponent);

  var _super = _createSuper(ContentBase);

  function ContentBase() {
    var _this;

    _classCallCheck(this, ContentBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      var _this$props = _this.props,
          chromelessFloating = _this$props.chromelessFloating,
          hasOpenMenu = _this$props.hasOpenMenu,
          setChromelessFloating = _this$props.setChromelessFloating;

      if (chromelessFloating && !hasOpenMenu) {
        _this.chromelessTimer = setTimeout(function () {
          setChromelessFloating(false);
        }, HIDE_CHROME_DELAY);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.clearChromelessTimer();
    });

    return _this;
  }

  _createClass(ContentBase, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearChromelessTimer();
    }
  }, {
    key: "clearChromelessTimer",
    value: function clearChromelessTimer() {
      if (this.chromelessTimer) {
        clearTimeout(this.chromelessTimer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          chromeless = _this$props2.chromeless,
          chromelessFloating = _this$props2.chromelessFloating,
          full = _this$props2.full,
          inverted = _this$props2.inverted;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('cloud-ui-page-content', {
          full: full,
          inverted: inverted
        }),
        onMouseEnter: chromeless ? this.onMouseEnter : undefined,
        onMouseLeave: chromeless ? this.onMouseLeave : undefined
      }, chromeless && !chromelessFloating && /*#__PURE__*/React.createElement(ChromelessControl, null), children);
    }
  }]);

  return ContentBase;
}(React.PureComponent);
export default (function (props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var chromeless = _ref.chromeless,
        chromelessFloating = _ref.chromelessFloating,
        setChromelessFloating = _ref.setChromelessFloating,
        hasOpenMenu = _ref.hasOpenMenu;
    return /*#__PURE__*/React.createElement(ContentBase, _extends({}, props, {
      chromeless: chromeless,
      chromelessFloating: chromelessFloating,
      setChromelessFloating: setChromelessFloating,
      hasOpenMenu: hasOpenMenu
    }));
  });
});